import styles from "./ProgressCircle.module.scss";

import ProgressCircleIcon from "~/assets/progress-circle.svg";

const ProgressCircle = () => {
  return <img src={ProgressCircleIcon} className={styles.progressCircle} />;
};

export default ProgressCircle;
